import { Box, FormControl, FormControlLabel, FormLabel, InputAdornment, Radio, RadioGroup, Stack, TextField, Typography } from '@mui/material'
import { useEffect } from 'react'
import { IFlowRunConfig } from '../../definitions/NodesExecution'

interface P {
    // flow: IFlow
    flowRunSettings: IFlowRunConfig
    setFlowRunSettings: (runSettings: IFlowRunConfig) => void
}

const DryRunSettings = ({ /* flow,  */flowRunSettings: flowRunSettings, setFlowRunSettings: setRunSettings }: P) => {
    // const [anchorEl, setAnchorEl] = React.useState<EventTarget & SVGSVGElement>(null)
    // const nodeWithSample = (flow.nodes.filter(x => x.type === 'xfrm_sql') as INode<'xfrm_sql'>[]).filter(x => x.dryRunConfig?.samplePercentage)

    useEffect(() => {
        if (!flowRunSettings?.dryRunConfig) {
            setRunSettings({
                ...flowRunSettings,
                dryRunConfig: {
                    ...flowRunSettings.dryRunConfig,
                    generateOutputs: true,
                    samplePercentage: 100
                }
            })
        }
    }, [])

    return (
        <>
            <Stack gap={2} spacing={2} paddingX={2}>
                <Typography variant='subtitle2' sx={{ paddingTop: 2 }}>Dry run configurations</Typography>
                <Box display='flex' flexDirection='row' alignItems='center'>
                    <TextField
                        color='dryRun'
                        sx={{ maxWidth: '40ch' }}
                        error={isNaN(flowRunSettings?.dryRunConfig?.samplePercentage)}
                        size='small'
                        InputProps={{ endAdornment: <InputAdornment position='end'>%</InputAdornment> }}
                        InputLabelProps={{ shrink: true }}
                        label='Sample:'
                        type='number'
                        value={String(flowRunSettings?.dryRunConfig?.samplePercentage)}
                        onChange={e => {
                            const newFlowRunSetting = structuredClone(flowRunSettings)
                            newFlowRunSetting.dryRunConfig.samplePercentage = parseFloat(e.target.value)
                            setRunSettings(newFlowRunSetting)
                        }}
                    />
                    {/* {nodeWithSample.length > 0 && (
                        <>
                            <LayersIcon
                                sx={{ marginLeft: 1 }}
                                aria-owns={open ? 'mouse-over-popover' : undefined}
                                aria-haspopup='true'
                                onMouseEnter={e => setAnchorEl(e.currentTarget)}
                                onMouseLeave={() => setAnchorEl(null)}
                            />
                            <Popover
                                id='mouse-over-popover'
                                sx={{ pointerEvents: 'none' }}
                                open={algo.hasVal(anchorEl)}
                                anchorEl={anchorEl}
                                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                                transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                                onClose={() => setAnchorEl(null)}
                                disableRestoreFocus>
                                <Typography sx={{ p: 1 }}>The following nodes have their sample value preset:</Typography>
                                {nodeWithSample.map(x => {
                                    return (
                                        <Typography key={x.uuid} sx={{ p: 1 }}>{x.name}: {x.dryRunConfig?.samplePercentage}%</Typography>
                                    )
                                })}
                            </Popover>
                        </>
                    )} */}
                </Box>
                <Stack flexDirection='row' gap={3} alignItems='center'>
                    <TextField
                        color='dryRun'
                        sx={{ maxWidth: '40ch' }}
                        size='small'
                        InputLabelProps={{ shrink: true }}
                        label='Seed:'
                        type='number'
                        value={flowRunSettings?.dryRunConfig?.overrideSeed}
                        onChange={e => {
                            const newFlowRunSetting = structuredClone(flowRunSettings)
                            newFlowRunSetting.dryRunConfig.overrideSeed = parseFloat(e.target.value)
                            setRunSettings(newFlowRunSetting)
                        }}
                    />
                    <FormControl>
                        <FormLabel id='generate-outputs-choice' color='dryRun'>
                            <Typography variant='subtitle2'>Outputs:</Typography>
                        </FormLabel>
                        <RadioGroup
                            row
                            name='generate-outputs-choice'
                            value={flowRunSettings?.dryRunConfig?.generateOutputs ?? 'true'}
                            onChange={e => {
                                const newFlowRunSetting = structuredClone(flowRunSettings)
                                newFlowRunSetting.dryRunConfig.generateOutputs = e.target.value === 'true'
                                setRunSettings(newFlowRunSetting)
                            }}>
                            <FormControlLabel value={true} control={<Radio color='dryRun' size='small' />} label='Yes' />
                            <FormControlLabel value={false} control={<Radio color='dryRun' size='small' />} label='No' />
                        </RadioGroup>
                    </FormControl>
                </Stack>
            </Stack>
        </>
    )
}

export default DryRunSettings
